import { ReportListItemApiModel } from '../../../api/reports/model/report-list-item-api.model';
import { AuditableModel } from '../../Misc/models/auditable.model';
import { TimeHelper } from '../../Forms/helpers/time.helper';
import { LeftSidebarListItemConvertableModel } from '../../../Common/Layout/models/left-sidebar-list-item-convertable.model';
import { LeftSidebarListItemButton } from '../../../Common/Layout/models/left-sidebar-list-item-button.model';
import { LeftSidebarListItem } from '../../../Common/Layout/models/left-sidebar-list-item.model';
import { ActionsEnum } from '../../Basic/enums/actions.enum';

export class ReportListItemModel implements AuditableModel, LeftSidebarListItemConvertableModel {
    id: number;
    name: string;
    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;
    hidden?: boolean;
    groupId: number;
    isFavorite: boolean = false;

    /**
     * Class constructor
     */
    constructor(apiModel?: ReportListItemApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.createdByUserId = apiModel.createdByUserId;
            this.createdDate = new Date(TimeHelper.convertTo13DigitTimestamp(apiModel.createdDate));
            this.modifiedByUserId = apiModel.lastModifiedByUserId;
            this.modifiedDate = apiModel.lastModifiedDate ? new Date(TimeHelper.convertTo13DigitTimestamp(apiModel.lastModifiedDate)) : null;
            this.hidden = apiModel.hidden;
            this.groupId = apiModel.displayGroupId;
            this.isFavorite = apiModel.isFavorited;
        } else {
            this.id = null;
            this.name = null;
            this.createdByUserId = null;
            this.createdDate = null;
            this.modifiedByUserId = null;
            this.modifiedDate = null;
            this.hidden = null;
        }
    }

    toLeftSidebarListItem(buttons?: LeftSidebarListItemButton[]): LeftSidebarListItem {
        const item = new LeftSidebarListItem();
        item.value = this.id;
        item.label = this.name;
        item.groupId = this.groupId;
        item.isFavorite = this.isFavorite;
        // item.status = `Reports.status.${this.status}`;
        if (this.hidden) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.hide);
        } else {
            buttons = buttons.filter(button => button.key !== ActionsEnum.show);
        }
        if (this.isFavorite) {
            buttons = buttons.filter(button => button.key !== ActionsEnum.favorite);
        } else {
            buttons = buttons.filter(button => button.key !== ActionsEnum.unfavorite);
        }
        item.buttons = buttons;
        return item;
    }

    /**
     * Converts this front end model to the back end version
     */
    public toApiModel(): ReportListItemApiModel {
        return {
            id: this.id,
            name: this.name,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate ? +this.createdDate : null,
            lastModifiedByUserId: this.modifiedByUserId,
            lastModifiedDate: this.modifiedDate ? +this.modifiedDate : null,
            hidden: this.hidden,
            displayGroupId: this.groupId,
            isFavorited: this.isFavorite
        };
    }
}
